import l from "./_arrayFromIterator.mjs";
import y from "./_includesWith.mjs";
import q from "./_functionName.mjs";
import v from "./_has.mjs";
import i from "./_objectIs.mjs";
import m from "../keys.mjs";
import p from "../type.mjs";
function d(e, r, n, a) {
  var s = l(e), t = l(r);
  function u(o, c) {
    return g(o, c, n.slice(), a.slice());
  }
  return !y(function(o, c) {
    return !y(u, c, o);
  }, t, s);
}
function g(e, r, n, a) {
  if (i(e, r))
    return !0;
  var s = p(e);
  if (s !== p(r))
    return !1;
  if (typeof e["fantasy-land/equals"] == "function" || typeof r["fantasy-land/equals"] == "function")
    return typeof e["fantasy-land/equals"] == "function" && e["fantasy-land/equals"](r) && typeof r["fantasy-land/equals"] == "function" && r["fantasy-land/equals"](e);
  if (typeof e.equals == "function" || typeof r.equals == "function")
    return typeof e.equals == "function" && e.equals(r) && typeof r.equals == "function" && r.equals(e);
  switch (s) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof e.constructor == "function" && q(e.constructor) === "Promise")
        return e === r;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof e == typeof r && i(e.valueOf(), r.valueOf())))
        return !1;
      break;
    case "Date":
      if (!i(e.valueOf(), r.valueOf()))
        return !1;
      break;
    case "Error":
      return e.name === r.name && e.message === r.message;
    case "RegExp":
      if (!(e.source === r.source && e.global === r.global && e.ignoreCase === r.ignoreCase && e.multiline === r.multiline && e.sticky === r.sticky && e.unicode === r.unicode))
        return !1;
      break;
  }
  for (var t = n.length - 1; t >= 0; ) {
    if (n[t] === e)
      return a[t] === r;
    t -= 1;
  }
  switch (s) {
    case "Map":
      return e.size !== r.size ? !1 : d(e.entries(), r.entries(), n.concat([e]), a.concat([r]));
    case "Set":
      return e.size !== r.size ? !1 : d(e.values(), r.values(), n.concat([e]), a.concat([r]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var u = m(e);
  if (u.length !== m(r).length)
    return !1;
  var o = n.concat([e]), c = a.concat([r]);
  for (t = u.length - 1; t >= 0; ) {
    var f = u[t];
    if (!(v(f, r) && g(r[f], e[f], o, c)))
      return !1;
    t -= 1;
  }
  return !0;
}
export {
  g as default
};
